type DialPropTypes = {
  type: string;
  value: string;
  action: React.Dispatch<React.SetStateAction<string>>;
};

function Dial(props: DialPropTypes) {
  const dials = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "00", "0"];
  const dialsAllDelete = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "전체삭제",
    "0",
  ];

  const deleteAction = () => {
    const prev = props.value;
    props.action(prev.slice(0, prev.length - 1));
  };

  return (
    <div className='dial-wrap T38B' style={{ color: "#636363" }}>
      {props.type === "all-delete"
        ? dialsAllDelete.map((v) =>
            v === "전체삭제" ? (
              <div
                className='dial-btn dial-style TO-button-2'
                onClick={() => {
                  props.action("0");
                }}
              >
                전체
                <br />
                삭제
              </div>
            ) : (
              <div
                className='dial-btn dial-style'
                onClick={() => {
                  props.action(props.value + v);
                }}
              >
                {v}
              </div>
            )
          )
        : props.type === "phone"
        ? dialsAllDelete.map((v) =>
            v === "전체삭제" ? (
              <div
                className='dial-btn dial-style TO-button-2'
                onClick={() => {
                  props.action("");
                }}
              >
                전체
                <br />
                삭제
              </div>
            ) : (
              <div
                className='dial-btn dial-style'
                onClick={() => {
                  props.action(props.value + v);
                }}
              >
                {v}
              </div>
            )
          )
        : dials.map((v) => (
            <div
              className='dial-btn dial-style'
              onClick={() => {
                props.action(props.value + v);
              }}
            >
              {v}
            </div>
          ))}
      {props.type === "all-delete" ? (
        <div
          className='dial-btn dial-style'
          onClick={() => {
            deleteAction();
          }}
        >
          <img src={"/assets/images/menu/dial_back.svg"} alt='delete number' />
        </div>
      ) : (
        <div
          className='dial-btn dial-style'
          onClick={() => {
            deleteAction();
          }}
        >
          <img src={"/assets/images/menu/dial_back.svg"} alt='delete number' />
        </div>
      )}
    </div>
  );
}
export default Dial;
